const striptags = (str: string) => str.replace(/<[^>]*>?/gm, '');

export default striptags;
